export default {
	products: {
		products: "Products",
		addProduct: "Add Product",
		addNewProduct: "+ Add New Product",
		searchProductsPlaceholder: "Search name",
		name: "Name",
		description: "Description",
		plan: "Plan",
		type: "Type",
		version: "Version",
		numberOfVersions: "Number of versions",
		createdAt: "Created at",
		createdBy: "Created by",
		status: "Status",
		info: "Info",
		underwriting: "Underwriting",
		pricing: "Pricing",
		benefits: "Benefits",
		remove: "Remove",
		save: "Save",
		update: "Update",
		delete: "Delete",
		deleteProduct: "Delete Product",
		Result: "Result",
		taxes: "Taxes",
		loadings: "Loadings",
		emptyText: "---",
		loadMore: "Load More",
		loading: "Loading...",
		cancel: "Cancel",
		required: "This field is required",
		addProductFailTitle: "Failed to create product",
		updateProductFailTitle: "Failed to update product",
		deleteProductFailTitle: "Failed to delete product",
		Required: "Required",
		requiredErrorMessage: "This field is required",
		allowSnakeCase: "This field only allow snake case (eg: travel_insurance)",
		typeDeleteToConfirm: "Type 'DELETE' to confirm",
		confirmDelete: "Are you sure you want to delete this product? This action can't be reverted.",
		addSuccess: "Add product successfully",
		updateSuccess: "Update product successfully",
		deleteSuccess: "Delete product successfully",
		dragSomeSubFieldsHere: "Drag some sub-fields here",
		edit: "Edit",
		subFields: "sub-fields",
		javascriptFunction: "JavaScript Function",
		youCanDefineRulesAsAJavascriptFunction: "You can define rules as a JavaScript function",
		removeEngine: "Remove Engine",
		jsonLogic: "Json Logic",
		youCanDefineRulesAsJSONLogic: "You can define rules as JSON Logic",
		no1: "1",
		no2: "2",
		no3: "3",
		pricingEngine: "Pricing Engine",
		dataInput: "Data Input",
		test: "Test",
		dragSomeDataFieldsFromTheTopMenuHere: "Drag some data fields from the top menu here",
		thisFeatureIsNotSupportedYet: "This feature is not supported yet :( We are working on it!",
		goBack: "Go Back",
		productInfo: "Product Info",
		result: "Result",
		underwritingEngine: "Underwriting Engine",
		discounts: "Discounts",
		parentTypeId: "Parent Type Id",
		typeId: "Type Id",
		technicalNameForTheBenefit: "Technical name for the benefit. Choose wisely because it can't be changed later.",
		benefitTypeId: "Benefit Type Id",
		shortValue: "Short Value",
		localizedShortValue: "Localized short value. It should be short and sweet.",
		detailedValue: "Detailed Value",
		localizedDetailedValue: "Localized detailed value. You can describe the benefit further.",
		seeLocalizationInstructions: "See Localization Instructions",
		toReferenceCurrencyCode: 'To reference the currency code, use "C1"',
		toReferenceValue: 'To reference the value, use "this"',
		forExample: "For example:",
		whenValueIs12AndCurrencyCodeIsHKD:
			'When value is 12 and currency code is HKD, write"{this|C1}" and displayed value will be HK$12',
		APIDocs: "API Docs",
		getAuthToken: "1. Get Auth Token",
		firstStepIsToGetToken: "First step is to get auth token based on your credentials",
		callPricingEngine: "Call pricing engine",
		callProductsQuery: "call products_2 query to get price of the product",
		insurer: "Insurer",
		insurerIsRequired: "Insurer is a required field",
		create: "Create",
		created: "Created",
		updated: "Updated",
		optionalBenefits: "Optional Benefits",
		thereAreCurrentlyNoBenefits: "There are currently no benefits. Start with adding the first one.",
		addBenefit: "Add Benefit",
		addChildBenefit: "Add Child Benefit",
		addMainBenefit: "Add Main Benefit",
		distributionChannels: "Distribution Channels",
		discountCodes: "Discount Codes",
		add: "Add",
		createProduct: "Create Product",
		versions: "Versions",
		createVersion: "Create Version",
		loadingCodes: "Loading Codes"
	}
}
